import { computed } from 'vue';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useApi, useToaster } from '@shopexperts/shared';

export function useSendReminder() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: ['expert', 'sendReminder'],
    mutationFn: async ({ reviewRequestId, message }: { reviewRequestId: number; message?: string }) => {
      return await api.expert.reviewsV2.sendReminder({
        params: { reviewRequest: reviewRequestId },
        body: { message },
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['expert', 'review-requests'] });

      toaster.create({
        title: 'Reminder sent successfully!',
        description: 'Your client will receive a reminder email shortly.',
        type: 'success',
      });
    },
    onError: (error: any) => {
      console.error('[useSendReminder] Error:', error);

      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        'Failed to send reminder. Please try again.';

      toaster.create({
        title: 'Error sending reminder',
        description: errorMessage,
        type: 'error',
      });
    },
  });

  const isSubmitting = computed(() => mutation.isPending.value);

  const sendReminder = (reviewRequestId: number, message?: string) => {
    return mutation.mutateAsync({ reviewRequestId, message });
  };

  return {
    sendReminder,
    isSubmitting,
  };
}
